import type { AffiliateExportFilters } from '@fluenceur/types';
import { lazy, Suspense } from 'react';
import type { FC } from 'react';
import { parseAsBoolean, useQueryState } from 'nuqs';

const AffiliateExportModalContent = lazy(() => import('./AffiliateExportModalContent'));

export type AffiliateExportBaseFilters = Pick<
  AffiliateExportFilters,
  | 'search'
  | 'status'
  | 'sort_by'
  | 'sort_direction'
  | 'date_filter_type'
  | 'start_date'
  | 'end_date'
  | 'source'
  | 'import_batch_id'
>;

interface AffiliateExportModalProps {
  presetProgramId?: string;
  filters: AffiliateExportBaseFilters;
  selectedAffiliateUserIds?: string[];
}

const AffiliateExportModal: FC<AffiliateExportModalProps> = ({
  presetProgramId,
  filters,
  selectedAffiliateUserIds = [],
}) => {
  const [isOpen] = useQueryState('affiliateExport', parseAsBoolean.withDefault(false));

  if (!isOpen) return null;

  return (
    <Suspense fallback={null}>
      <AffiliateExportModalContent
        presetProgramId={presetProgramId}
        filters={filters}
        selectedAffiliateUserIds={selectedAffiliateUserIds}
      />
    </Suspense>
  );
};

export default AffiliateExportModal;
